import React from 'react';
import { getTypeLabels } from '../../TypeTreePicker/Utils/typeConditionUtils';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { ITypeTreeConditionObject } from '../../../../../../../Types/UrvalTypes';

interface IProps {
  conditionObject: ITypeTreeConditionObject;
  disabled?: boolean;
}

class TypeConditionValues extends React.Component<IProps> {
  render() {
    const { conditionObject, disabled } = this.props;
    return (
      <EDTypography color={disabled ? 'textSecondary' : 'inherit'}>
        {getTypeLabels(conditionObject).join(', ')}
      </EDTypography>
    );
  }
}

export default TypeConditionValues;
